/**
 Author - Muhamed Afsal
 Git - https://bitbucket.org/mohdafsal/
 **/

const suitcaseIcon = "https://i.wlycdn.com/wealth-managers/agent-onboarding-suitcase.png";
const bankIcon = "https://i.wlycdn.com/wealth-managers/agent-onboarding-bank.png";
const umbrellaIcon = "https://i.wlycdn.com/wealth-managers/agent-onboarding-insurance.png";
const buildingIcon = "https://i.wlycdn.com/wealth-managers/agent-onboarding-occupation-nonfinance.svg";
const thumbsUpIcon = "https://i.wlycdn.com/wealth-managers/agent-onboarding-occupation-other.svg";
const coinIcon = "https://i.wlycdn.com/wealth-managers/agent-onboarding-sales.png";
const priceBagIcon = "https://i.wlycdn.com/wealth-managers/agent-onboarding-occupation-finance.png";

const reasonToJoin = {
  question: "how can Wealthy help you succeed?",
  description:
      "this will help us know you better as a wealth partner",
  answerKey: "reason_to_join",
  options: [
    {
      icon: coinIcon,
      title: "by helping me establish a second source of income",
      subtitle: "",
      next: null,
      value: "second income source"
    },
    {
      icon: priceBagIcon,
      title: "by allowing me to quit and start my own finance business",
      subtitle: "",
      next: null,
      value: "start own finance business"
    }
  ]
};

const currentRole = {
  question: "what's your current role?",
  description:
      "this will help us know you better as a wealth partner",
  answerKey: "profession_role",
  options: [
    {
      icon: coinIcon,
      title: "sales",
      value: "sales",
      next: reasonToJoin
    },
    {
      icon: thumbsUpIcon,
      title: "other",
      value: "other",
      next: reasonToJoin
    }
  ]
};

const fullTimeJobQuestions = {
  icon: suitcaseIcon,
  title: "i work at a full time job",
  subtitle: "i am currently employed with a company",
  value: "FTJ",
  next: {
    question: "which sector do you work in?",
    answerKey: "product_experience",
    description:
        "this will help us know you better as a wealth partner",
    options: [
      {
        icon: bankIcon,
        title: "banking sector",
        subtitle: "HDFC, ICICI, SBI and others",
        value: "BS",
        next: currentRole
      },
      {
        icon: umbrellaIcon,
        title: "insurance company",
        subtitle: "ICICI Lombard, HDFC Ergo, LIC etc",
        value: "IC",
        next: currentRole
      },
      {
        icon: buildingIcon,
        title: "other financial company",
        subtitle: "finance org, neither banking nor insurance",
        value: "OFC",
        next: currentRole
      },
      {
        icon: thumbsUpIcon,
        title: "non financial company",
        subtitle: "non financial org",
        value: "NFC",
        next: currentRole
      }
    ]
  }
};

export default fullTimeJobQuestions;
